// src/lib/usePostHogPageview.js
//
// PostHog (see the inline init snippet in public/index.html) only ever
// captures one pageview automatically: whichever URL was loaded when its
// script first ran. On a client-side-routed SPA, every subsequent
// navigation - Home to Services to a specific service, all without a full
// page reload - fired zero further events, so a real multi-page visit
// showed up in analytics as a single pageview with no way to see where
// visitors went next. Nothing in the codebase wired route changes to
// PostHog at all before this - found via a plain grep, not a guess.
//
// Scoped to the public site only (mounted in PublicSite(), not admin) -
// admin usage isn't customer funnel data PostHog needs to see.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function usePostHogPageview() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the very first render - PostHog's own init snippet already
    // captures that initial pageview itself; firing again here would
    // double-count the landing page.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window !== "undefined" && window.posthog?.capture) {
      window.posthog.capture("$pageview");
    }
  }, [location.pathname, location.search]);
}
